import { useNavigate } from 'react-router-dom';
import BackButton from '../components/reusable/buttons/BackButton';
import Header from '../components/reusable/Header';
import PageTitle from '../components/reusable/PageTitle';
import { dispatch } from '../redux/store';
import SwitchButton from '../components/pageComponents/Custom/Switch';
import { useState } from 'react';
import { getSingleModel } from '../utils/helpers';
import Spinner from '../components/reusable/spinner/Spinner';
import { useSelector } from 'react-redux';

const PROFILE_STATUS = { private: 'private', public: 'public' };

const Settings = () => {
    const navigate = useNavigate();
    const profileShareStatus =
        getSingleModel('auth')?.authUser?.userInfo?.profileShareStatus ||
        'public';
    const [profileShareStatusState, setProfileShareStatusState] = useState(
        PROFILE_STATUS[profileShareStatus]
    );
    const [isSettingProfileStatus, setIsSettingProfileStatus] = useState(false);
    const settings = [
        {
            title: 'ACCOUNT SETTINGS',
            linkPath: '/settings/account'
        },
        {
            title: 'PRIVACY AND SECURITY',
            linkPath: '/settings/account/privacy-and-security'
        }
    ];

    const { userInfo } = useSelector(state => state.auth.authUser);

    const handlePrivateProfileToggle = async () => {
        try {
            setIsSettingProfileStatus(true);
            const newStatus =
                profileShareStatusState === PROFILE_STATUS.private
                    ? PROFILE_STATUS.public
                    : PROFILE_STATUS.private;

            const userId = getSingleModel('auth')?.authUser?.userInfo?.id;
            if (!userId) {
                throw new Error('User ID not found');
            }

            await dispatch.user.updateUser({
                id: userId,
                profileShareStatus: newStatus
            });

            setProfileShareStatusState(newStatus);
        } catch (error) {
            console.error('Failed to update profile sharing status:', error);
            // Optionally show error notification to user
        } finally {
            setIsSettingProfileStatus(false);
        }
    };

    async function handleLogout() {
        await dispatch.auth.logout();
        navigate('/');
    }
    return (
        <div className='page md:max-w-[700px] mx-auto'>
            <Header>
                <BackButton from='' />
            </Header>
            <PageTitle>
                <div className='text-[20px] uppercase'>Settings</div>
            </PageTitle>
            <div className='mt-[65px]'>
                {settings.map(({ linkPath, title }, i) => (
                    <div
                        onClick={() => navigate(linkPath)}
                        key={i}
                        className='flex justify-between items-center py-[20px] cursor-pointer'
                    >
                        <p className='uppercase text-[15px] font-favela-bold font-bold'>
                            {title}
                        </p>
                        <img src='/images/arrowRight.svg' alt='' />
                    </div>
                ))}
                {userInfo?.userType === 'PLAYER' && (
                    <div className='py-[20px]'>
                        <div className='flex justify-between w-full mb-4 items-center'>
                            <p className='text-[14px]'>
                                Profile Sharing{' '}
                                {profileShareStatusState ===
                                PROFILE_STATUS.public
                                    ? 'On'
                                    : 'Off'}
                            </p>
                            <div className='flex-[15%] ml-2'>
                                <SwitchButton
                                    inActiveBgColor='bg-white border border-black'
                                    labelPosition='left'
                                    text=''
                                    textFont='font-semibold'
                                    checked={
                                        profileShareStatusState ===
                                        PROFILE_STATUS.public
                                    }
                                    LoadingIcon={<Spinner type={'circle'} />}
                                    ballActiveColor='after:bg-black'
                                    checkedBgColorClass='checked-green-bg'
                                    small={true}
                                    isLoading={isSettingProfileStatus}
                                    className=''
                                    handleCheckboxChange={() => {
                                        handlePrivateProfileToggle();
                                    }}
                                />
                            </div>
                        </div>
                        <p className='text-[10px] text-opacity-50 italic text-black font-poppins'>
                            Your profile and videos can be shared via secure
                            links and viewed by scouts, agents, and coaches who
                            receive them.
                        </p>
                    </div>
                )}
            </div>
            <div className='absolute bottom-10 left-0 text-center w-full'>
                <p
                    onClick={handleLogout}
                    className='font-favela mt-5 underline'
                >
                    Log out
                </p>
            </div>
        </div>
    );
};

export default Settings;
